import templates from "../templates";

import jQuery from "jquery";
import { EVENT, MOBILE_BREAKPOINT, currency } from "../data/constants";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import {
    EventManager,
    addBrandIconForDetailView,
    concatenateStoreHours,
    formatAddressLines,
    formatDateByCountry,
    formatStoreDistanceValue,
    formatZipCityAddress,
    generateHoursLiArray,
    getMoreInfoLink,
    getProductHotData,
    getProductImageUrl,
    getProductName,
    initIcons,
    open247,
} from "../utils/global";
import { showAllPOICards } from "../utils/ui";

const $ = jQuery;

export default class DetailView {
    constructor(sidePanel, language) {
        this.sidePanel = sidePanel;

        this.mainSelector = "#storemap-detailbar-container";
        this.mainElement = document.querySelector(this.mainSelector);

        this.secondSelector = "#storemap-gothere-container";
        this.secondElement = document.querySelector(this.secondSelector);

        const detailContext = { ...total.maps.L10n.ui, itinerary: SETTINGS.itinerary };
        const minifiche = SETTINGS.quadran
            ? templates.desktop.quadran.render(detailContext)
            : templates.desktop.detail.render(detailContext);
        this.mainElement.innerHTML = minifiche;
        this.language = language;
        this._wireEvents();
    }

    __handleCloseClick() {
        if (this.sidePanel.isDetailFromItinerary()) {
            this.sidePanel.resumeDirectionView();
        } else {
            this.sidePanel.showSearchResultView();
            this.sidePanel.onResetHighlightedStoreOnRoute();
            SERVICE_REGISTRY.storeService.resetSelectedStore();
        }
    }
    _wireEvents() {
        const onCloseButtonClick = () => {
            this.__handleCloseClick();
        };

        const onDirectionButtonClick = () => {
            SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = true;
            SETTINGS.isSearchAlongTheRouteActive = false;
            // Capture selectedStore before the swap: resumeDirectionView()
            // (called inside swapItineraryDestination) resets it.
            const selectedStore = SERVICE_REGISTRY.storeService.getSelectedStore();
            if (this.sidePanel.isDetailFromItinerary()) {
                this.sidePanel.swapItineraryDestination();
            } else {
                this.sidePanel.showDirectionView();
            }
            EventManager.notify(EVENT.GO_CLICKED, selectedStore.properties.store_id);
        };

        const onWebUrlLinkClick = () => {
            EventManager.notify(EVENT.DETAIL_CLICKED, null);
        };
        const closeButtonElement = this.mainElement.querySelector(".wm-poi-detail--footer button");
        if (closeButtonElement) {
            closeButtonElement.addEventListener("click", onCloseButtonClick);
            closeButtonElement.addEventListener("keydown", function (event) {
                if (["Enter", " ", "Space"].includes(event.key)) {
                    event.preventDefault();
                    onCloseButtonClick.call(this, event);
                }
            });
        }
        // The directions section is gated on {{#itinerary}}, so it may not exist (e.g. aviation).
        const directionsElement = this.mainElement.querySelector(".wm-poi-detail--directions");
        if (directionsElement) {
            directionsElement.addEventListener("click", onDirectionButtonClick);
        }
        const directionsSection = this.mainElement.querySelector('[data-id="directions"]');
        if (directionsSection) {
            directionsSection.addEventListener("keydown", function (event) {
                if (["Enter", " ", "Space"].includes(event.key)) {
                    event.preventDefault();
                    onDirectionButtonClick.call(this, event);
                }
            });
        }
        if (this.secondElement) {
            this.secondElement.addEventListener("click", onDirectionButtonClick);
            this.secondElement.addEventListener("keydown", function (event) {
                if (["Enter", " ", "Space"].includes(event.key)) {
                    event.preventDefault();
                    onDirectionButtonClick.call(this, event);
                }
            });
        }

        this.mainElement.querySelector(".storemap-web-url-link").addEventListener("click", onWebUrlLinkClick);
    }
    _wireEventsForMinifiedView(store) {
        const onCloseButtonClick = () => {
            this.__handleCloseClick();
        };
        const onStoreContainerClick = () => {
            this.mainElement.innerHTML = templates.desktop.detail.render({
                ...total.maps.L10n.ui,
                itinerary: SETTINGS.itinerary,
            });
            // this is explicitly set to close when user comes from minified view to details view
            if (document.querySelector(".wm-poi-detail--footer button")) {
                document.querySelector(".wm-poi-detail--footer button").textContent = total.maps.L10n.ui.common.close;
                document.querySelector(".wm-poi-detail--footer button").innerHTML =
                    `<i data-icon="close" data-size="18"></i><span>${total.maps.L10n.ui.common.close}</span>`;
            }
            this.sidePanel.setStoreSelectedFromMap(false);
            this._generateDetailContainer(store);
            initIcons();
            this._wireEvents();
        };

        // The click bubbles to .wm-poi-card, whose handler renders the details; rendering here
        // too fetched hot data twice (#205). With async distances (itinerary), the old render
        // finished last and set the footer label, so re-apply it after the card handler.
        const onMoreDetailButtonClick = () => {
            EventManager.notify(EVENT.MORE_INFORMATION_CLICKED, store.properties.store_id);
            if (SERVICE_REGISTRY.locationService.isUserCurrentLocation()) {
                setTimeout(() => this._updateCloseButton());
            }
        };

        const onDirectionButtonClick = (event) => {
            event.stopPropagation();

            SERVICE_REGISTRY.storeService.setSelectedStore(store);

            SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = true;
            SETTINGS.isSearchAlongTheRouteActive = false;
            if (this.sidePanel.isDetailFromItinerary()) {
                this.sidePanel.swapItineraryDestination();
            } else {
                this.sidePanel.showDirectionView();
            }

            EventManager.notify(EVENT.GO_CLICKED, store.properties.store_id);
        };
        const onHeaderBarClicked = (event) => {
            event.stopPropagation();
            this.sidePanel.showSearchResultView();
            showAllPOICards();
        };
        this.mainElement.querySelector(".wm-poi-card").addEventListener("click", onStoreContainerClick);
        this.mainElement.querySelector(".wm-poi-card").addEventListener("keydown", (event) => {
            if (["Enter", " ", "Space"].includes(event.key)) {
                event.preventDefault();
                onStoreContainerClick.call(this, event);
            }
        });
        this.mainElement.querySelector(".wm-poi-card--details-link").addEventListener("click", onMoreDetailButtonClick);
        // The directions button is gated on {{#itinerary}}, so it may not exist (e.g. aviation).
        const openDirectionsButton = this.mainElement.querySelector(".wm-btn-open-directions");
        if (openDirectionsButton) {
            openDirectionsButton.addEventListener("click", onDirectionButtonClick);
            openDirectionsButton.addEventListener("keydown", (event) => {
                if (["Enter", " ", "Space"].includes(event.key)) {
                    event.preventDefault();
                    onDirectionButtonClick.call(this, event);
                }
            });
        }
        this.mainElement.querySelector(".wm-poi-list--header")?.addEventListener("click", onHeaderBarClicked);
        const closeButtonElement = this.mainElement.querySelector(".wm-poi-detail--footer button");
        if (closeButtonElement) {
            closeButtonElement.addEventListener("click", onCloseButtonClick);
            closeButtonElement.addEventListener("keydown", function (event) {
                if (["Enter", " ", "Space"].includes(event.key)) {
                    event.preventDefault();
                    onCloseButtonClick.call(this, event);
                }
            });
        }
    }

    show() {
        this.mainElement.style.display = "";
        if (!SETTINGS.quadran && this.secondElement) {
            this.secondElement.style.display = "";
        }
        const height = document.querySelector("#map-canvas").getBoundingClientRect().height;
    }

    hide() {
        this.mainElement.style.display = "none";
        if (this.secondElement) {
            this.secondElement.style.display = "none";
        }
    }

    showDetails(selectedStore) {
        const detailEl = this.mainElement.querySelector(".wm-poi-detail");
        if (detailEl) {
            detailEl.classList.add("wm-hidden");
        }

        if (this._isMobileMinifiedView()) {
            this.mainElement.innerHTML = "";
            this.sidePanel.updateStoreDistance([selectedStore], () => {
                this._cleanupEvents();
                this._generateDetailMinified(selectedStore);
                this._updateCloseButton();
                this._wireEventsForMinifiedView(selectedStore);
            });
        } else {
            if (!detailEl) {
                this._cleanupEvents();
                this.mainElement.innerHTML = templates.desktop.detail.render({
                    ...total.maps.L10n.ui,
                    itinerary: SETTINGS.itinerary,
                });
                this._wireEvents();
            }

            this.sidePanel.updateStoreDistance([selectedStore], () => {
                this._updateCloseButton();
                this._generateDetailContainer(selectedStore);
            });
        }
    }

    _isMobileMinifiedView() {
        return this.sidePanel.getStoreSelectedFromMap() && this._isMobileView();
    }
    _isMobileView() {
        return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    _updateCloseButton() {
        const closeButton = this.mainElement.querySelector(".wm-poi-detail--footer button");
        if (!closeButton) return;

        if (this.sidePanel.isDetailFromItinerary()) {
            if (this._isMobileView()) {
                // Mobile: itinerary panel stays visible, just dismiss the minified card
                closeButton.innerHTML = `<i data-icon="close" data-size="18"></i><span>${total.maps.L10n.ui.common.close}</span>`;
            } else {
                // Desktop: navigate back to the itinerary panel
                const icon = "close";
                const text = total.maps.L10n.ui.common.back_to_itinerary || "Return to itinerary"; // fallback until backend adds key
                closeButton.innerHTML = `<i data-icon="${icon}" data-size="24"></i><span>${text}</span>`;
                closeButton.setAttribute("aria-label", text);
            }

            window.reinitIcons();
            return;
        }

        const isStoreFromMap = this.sidePanel.getStoreSelectedFromMap();
        const nearByStores = this.sidePanel.resultsView.getStores() || [];
        const showCloseIcon = isStoreFromMap && nearByStores.length === 0;
        const icon = showCloseIcon ? "close" : "back";
        const iconSize = showCloseIcon ? "18" : "24";
        const text = showCloseIcon ? total.maps.L10n.ui.common.close : total.maps.L10n.ui.common.back_to_list;

        closeButton.innerHTML = `<i data-icon="${icon}" data-size="${iconSize}"></i><span>${text}</span>`;
        window.reinitIcons();
    }
    _cleanupEvents() {
        // Clean up summary view event listeners
        const storeCard = this.mainElement.querySelector(".wm-poi-card");
        const detailsLink = this.mainElement.querySelector(".wm-poi-card--details-link");
        const directionsButton =
            this.mainElement.querySelector(".wm-btn-open-directions") ||
            this.mainElement.querySelector(".wm-poi-detail--directions");
        const headerBar = this.mainElement.querySelector(".wm-poi-list--header");
        const closeButton = this.mainElement.querySelector(".wm-poi-detail--footer button");
        const webUrlLink = this.mainElement.querySelector(".storemap-web-url-link");

        // Remove store card events
        if (storeCard) {
            storeCard.replaceWith(storeCard.cloneNode(true));
        }

        // Remove details link events
        if (detailsLink) {
            detailsLink.replaceWith(detailsLink.cloneNode(true));
        }

        // Remove directions button events
        if (directionsButton) {
            directionsButton.replaceWith(directionsButton.cloneNode(true));
        }

        // Remove header bar events
        if (headerBar) {
            headerBar.replaceWith(headerBar.cloneNode(true));
        }

        // Remove close button events
        if (closeButton) {
            closeButton.replaceWith(closeButton.cloneNode(true));
        }

        // Remove web link events
        if (webUrlLink) {
            webUrlLink.replaceWith(webUrlLink.cloneNode(true));
        }

        // Remove second element events
        if (this.secondElement) {
            const clone = this.secondElement.cloneNode(true);
            this.secondElement.replaceWith(clone);
            this.secondElement = clone;
        }
    }
    showMinifiedDetailView(selectedStore) {
        this._generateDetailMinified(selectedStore);
    }
    _generateDetailMinified(store) {
        const stores = this.sidePanel.resultsView.getStores();
        const poiType = store?.properties?.user_properties?.poiType.toLowerCase();
        const item = $(
            $.parseHTML(
                templates.desktop.detailMini.render({
                    ui: total.maps.L10n.ui,
                    itinerary: SETTINGS.itinerary,
                    index: 0,
                    name: store.properties.name || "",
                    showHeader: false,
                    isSearchAlongTheRouteActive: SETTINGS.isSearchAlongTheRouteActive,
                }),
            ),
        );

        // index css
        item.attr("id", `storemap-store-id-${store.properties.store_id}`);

        // icon
        let url;

        item.attr("brand", store.properties.user_properties.brand);

        item.attr("poiType", store.properties.user_properties.poiType);

        if (SETTINGS.iconUrls.brand[store.properties.user_properties.brand]) {
            url =
                SETTINGS.iconUrls.brand[store.properties.user_properties.brand].marker[poiType] ??
                SETTINGS.defaultBrandIcon;
        } else {
            url = SETTINGS.defaultBrandIcon;
        }

        item.find(".wm-poi-card--img")[0].src = url;
        item.find(".wm-poi-card--img")[0].alt = store.properties.name;

        // name
        item.find(".wm-poi-card--title")[0].innerText = store.properties.name;

        // type — aviation hides the AIRPORT/AIRFIELD distinction on the minified card.
        const type = store.properties.user_properties.poiType;
        const poiTypeToDisplay = total.maps.L10n.ui.poiType[type] ? total.maps.L10n.ui.poiType[type] : type;
        item.find(".wm-poi-card--type")[0].innerText = SETTINGS.isAviationPortal ? "" : poiTypeToDisplay;

        // open
        if (store.properties.open?.open_now) {
            const hoursText = concatenateStoreHours(store.properties.open.open_hours);
            item.find(".wm-poi-card--hours-item p")[0].innerText = `${total.maps.L10n.ui.common.today} ${hoursText}`;
            item.find(".wm-poi-card--hours-item p")[0].parentElement.classList.remove("wm-hidden");
        } else {
            item.find(".wm-poi-card--hours-item p")[0].parentElement.classList.add("wm-hidden");
            item.find(".storemap-storelistitem-todayshours").hide();
        }

        // open 24/7
        const p = item.find('.wm-poi-card--hours-item i[data-icon="fuel"]')[0].parentElement.querySelector("p");
        if (p) {
            if (open247(store)) {
                p.innerText = "24/7";
                item.find('.wm-poi-card--hours-item i[data-icon="fuel"]')[0].parentElement.classList.remove(
                    "wm-hidden",
                );
            } else {
                item.find('.wm-poi-card--hours-item i[data-icon="fuel"]')[0].parentElement.classList.add("wm-hidden");
            }
        }

        // distance
        const durationText =
            store.properties.durationText || (store.properties.duration && formatDuration(store.properties.duration));

        if (durationText) {
            item.find(".wm-poi-card--distance")[0].innerText = durationText;
        }

        // address
        const address = formatAddressLines(store);
        const zipCityText = formatZipCityAddress(store);
        item.find(".wm-poi-card--address")[0].innerText = [address, zipCityText].filter(Boolean).join("·");
        // phone
        if (store.properties.contact.phone) {
            item.find(".storemap-telephone-number").text(store.properties.contact.phone);
        } else {
            item.find(".storemap-storelistitem-info-telephone").hide();
        }
        this.mainElement.innerHTML = item[0].outerHTML;
        initIcons();
    }

    _generateDetailContainer(store) {
        const selectedStore = store;
        const container = this.mainElement.querySelector(".wm-poi-detail");
        container.classList.add("wm-hidden");
        container.querySelector(".storemap-detailitem-info-fuel").style.display = "none";
        if (container.querySelector("#legal-notice")) {
            container.querySelector("#legal-notice").style.display = "none";
        }

        // class icon
        addBrandIconForDetailView(container.querySelector(".wm-poi-detail--header-img"), selectedStore);

        // distance
        let howToGoBaliseText = `<span class="storemap-icon"></span>${total.maps.L10n.ui.common.go} `;
        if (selectedStore.properties.distance) {
            howToGoBaliseText += `- <strong>${formatStoreDistanceValue(selectedStore)}</strong>`;
            this.mainElement.querySelector(".wm-poi-detail--eta").classList.remove("wm-hidden");
            this.mainElement.querySelector(".wm-poi-detail--eta p:nth-of-type(1)").textContent =
                `Distance: ${formatStoreDistanceValue(selectedStore)}`;
        } else {
            this.mainElement.querySelector(".wm-poi-detail--eta").classList.add("wm-hidden");
        }

        if (selectedStore.properties.durationText) {
            this.mainElement.querySelector(".wm-poi-detail--eta").classList.remove("wm-hidden");
            this.mainElement.querySelector(".wm-poi-detail--eta p:nth-of-type(2)").textContent =
                `${total.maps.L10n.ui.common.duration || "Duration"}: ${selectedStore.properties.durationText}`;
        } else {
            this.mainElement.querySelector(".wm-poi-detail--eta").classList.add("wm-hidden");
        }

        if (this.secondElement) {
            this.secondElement.innerHTML = howToGoBaliseText;
        }

        // name
        this.mainElement.querySelector(".wm-poi-detail--header-title").textContent = selectedStore.properties.name;

        // type
        const headerTypeElement = this.mainElement.querySelector(".wm-poi-detail--header-type");
        if (SETTINGS.isAviationPortal) {
            // Aviation: hide the AIRPORT/AIRFIELD distinction; show airport identifiers instead.
            // Authoritative keys are code_iata / code_icao; fall back to the legacy iata_code.
            const userProperties = store.properties.user_properties ?? {};
            const iataCode = userProperties.code_iata || userProperties.iata_code;
            const icaoCode = userProperties.code_icao;
            headerTypeElement.textContent = [iataCode, icaoCode].filter(Boolean).join(" / ");
        } else {
            const type = store.properties.user_properties.poiType;
            const poiTypeToDisplay = total.maps.L10n.ui.poiType[type] ? total.maps.L10n.ui.poiType[type] : type;
            headerTypeElement.textContent = poiTypeToDisplay;
        }

        // Dirty Quadran implementation ...
        if (SETTINGS.quadran) {
            const poiName = selectedStore.properties.name;
            const typeDeSite = selectedStore.properties.user_properties.type_de_site ?? "";
            const exploitePour = selectedStore.properties.user_properties.exploite_pour ?? "";
            const commune = selectedStore.properties.user_properties.commune ?? "";
            const departement = selectedStore.properties.user_properties.departement ?? "";
            const region = selectedStore.properties.user_properties.region ?? "";
            const miseEnService = selectedStore.properties.user_properties.mise_en_service ?? "";
            const puissance = selectedStore.properties.user_properties.puissance ?? "";
            const caracterisitiques = selectedStore.properties.user_properties.caracteristiques ?? "";
            const photo = selectedStore.properties.user_properties.photo ?? "";

            this.mainElement.querySelector("#poi-name").textContent = poiName;
            this.mainElement.querySelector("#type-site-val").textContent = typeDeSite;
            this.mainElement.querySelector("#exploite-pour-val").textContent = exploitePour;
            this.mainElement.querySelector("#commune-val").textContent = commune;
            this.mainElement.querySelector("#departement-val").textContent = departement;
            this.mainElement.querySelector("#region-val").textContent = region;

            this.mainElement.querySelector("#mise-en-service-val").textContent = miseEnService;
            this.mainElement.querySelector("#caracteristiques-val").textContent = caracterisitiques;
            this.mainElement
                .querySelector("#poi-img")
                .setAttribute("src", `https://ressources.total.com/images-vista/quadran/${photo}`);

            let formattedPuissance = puissance;
            if (puissance) {
                formattedPuissance = `${puissance.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")} kW`;
            }
            this.mainElement.querySelector("#puissance-val").textContent = formattedPuissance;

            const exploitePourText = exploitePour === "Total Quadran" ? "Exploité par" : "Exploité pour";
            this.mainElement.querySelector("#exploite-pour-text").textContent = exploitePourText;

            const statusArray = selectedStore.properties.tags;
            let miseEnServiceText = "Mise en service";
            if (statusArray.includes("en-construction") || statusArray.includes("en-developpement")) {
                miseEnServiceText = "Mise en service prévue";
            }
            this.mainElement.querySelector("#mise-en-service-text").textContent = miseEnServiceText;
        }

        // The IATA/ICAO codes are rendered into the header type slot above (aviation only).

        // open
        if (selectedStore.properties.open?.open_now) {
            document.querySelector(".wm-poi-detail--section-status-details p").classList.remove("wm-hidden");
            const hoursText = concatenateStoreHours(selectedStore.properties.open.open_hours);
            document.querySelector(".wm-poi-detail--section-status-details p").textContent =
                `${total.maps.L10n.ui.common.today} ${hoursText}`;
        } else {
            document.querySelector(".wm-poi-detail--section-status-details p").classList.add("wm-hidden");
        }

        // address
        const address = formatAddressLines(selectedStore);
        const zipCityText = formatZipCityAddress(store);
        // The address lives inside the directions section, which is gated on {{#itinerary}}.
        const addressTextElement = this.mainElement.querySelector(".wm-poi-detail--address");
        if (addressTextElement) {
            addressTextElement.textContent = [address, zipCityText].filter(Boolean).join(" ");
        }

        const addressElem = document.querySelector('[data-id="directions"]');
        if (addressElem?.classList.contains("wm-hidden")) {
            addressElem.classList.remove("wm-hidden");
        }
        // phone
        if (
            selectedStore.properties.user_properties.contacts?.first_tel &&
            selectedStore.properties.user_properties.contacts.first_tel.value !== ""
        ) {
            this.mainElement.querySelector(".storemap-detailitem-info-telephone").style.display = "";
            this.mainElement.querySelector(".storemap-telephone-number").textContent =
                selectedStore.properties.user_properties.contacts.first_tel.value;

            const blockElement = this.mainElement.querySelector(".storemap-telephone-block");
            if (SETTINGS.isAviationPortal) {
                const { name } = selectedStore.properties.user_properties.contacts.first_tel;
                const { job } = selectedStore.properties.user_properties.contacts.first_tel;

                const nameElement = this.mainElement.querySelector(".storemap-telephone-name");
                const jobElement = this.mainElement.querySelector(".storemap-telephone-job");
                const separatorElement = this.mainElement.querySelector(".storemap-telephone-separator");

                // dirty, needs to be refactored
                if (name && name !== "" && job && job !== "") {
                    nameElement.textContent = name;
                    jobElement.textContent = job;
                    separatorElement.style.display = "";
                    blockElement.style.display = "";
                } else if (name && name !== "") {
                    nameElement.textContent = name;
                    blockElement.style.display = "";
                } else if (job && job !== "") {
                    nameElement.textContent = job;
                    blockElement.style.display = "";
                } else {
                    nameElement.textContent = "";
                    jobElement.textContent = "";
                    separatorElement.style.display = "none";
                    blockElement.style.display = "none";
                }
            } else {
                blockElement.style.viibility = "hidden";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-telephone").style.display = "none";
        }

        // phone 2
        if (SETTINGS.isAviationPortal) {
            if (
                selectedStore.properties.user_properties.contacts?.second_tel &&
                selectedStore.properties.user_properties.contacts.second_tel.value !== ""
            ) {
                this.mainElement.querySelector(".storemap-detailitem-info-telephone2").style.display = "";
                this.mainElement.querySelector(".storemap-telephone2-number").textContent =
                    selectedStore.properties.user_properties.contacts.second_tel.value;

                const { name } = selectedStore.properties.user_properties.contacts.second_tel;
                const { job } = selectedStore.properties.user_properties.contacts.second_tel;

                const blockElement = this.mainElement.querySelector(".storemap-telephone2-block");
                const nameElement = this.mainElement.querySelector(".storemap-telephone2-name");
                const jobElement = this.mainElement.querySelector(".storemap-telephone2-job");
                const separatorElement = this.mainElement.querySelector(".storemap-telephone2-separator");

                // dirty, needs to be refactored
                if (name && name !== "" && job && job !== "") {
                    nameElement.textContent = name;
                    jobElement.textContent = job;
                    separatorElement.style.display = "";
                    blockElement.style.display = "";
                } else if (name && name !== "") {
                    nameElement.textContent = name;
                    blockElement.style.display = "";
                } else if (job && job !== "") {
                    nameElement.textContent = job;
                    blockElement.style.display = "";
                } else {
                    nameElement.textContent = "";
                    jobElement.textContent = "";
                    separatorElement.style.display = "none";
                    blockElement.style.display = "none";
                }
            } else {
                this.mainElement.querySelector(".storemap-detailitem-info-telephone2").style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-telephone2").style.display = "none";
        }

        // website

        // if(SETTINGS.isAviationPortal){
        if (selectedStore.properties.user_properties.contacts?.website?.value) {
            this.mainElement.querySelector(".storemap-detailitem-info-website").style.display = "";
            const websiteLink = this.mainElement.querySelector(
                ".storemap-detailitem-info-website .storemap-web-url-link",
            );
            websiteLink.setAttribute("href", selectedStore.properties.user_properties.contacts.website.value);
            if (
                selectedStore.properties.user_properties.contacts.website.name &&
                selectedStore.properties.user_properties.contacts.website.name !== ""
            ) {
                websiteLink.textContent = selectedStore.properties.user_properties.contacts.website.name;
            } else {
                websiteLink.textContent = "Website";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-website").style.display = "none";
        }

        // fax
        if (SETTINGS.isAviationPortal) {
            if (
                selectedStore.properties.user_properties.contacts?.fax &&
                selectedStore.properties.user_properties.contacts.fax.value !== ""
            ) {
                this.mainElement.querySelector(".storemap-detailitem-info-fax").style.display = "";
                this.mainElement.querySelector(".storemap-fax-number").textContent =
                    selectedStore.properties.user_properties.contacts.fax.value;
                this.mainElement.querySelector(".storemap-fax-name").textContent =
                    selectedStore.properties.user_properties.contacts.fax.name;
                this.mainElement.querySelector(".storemap-fax-job").textContent =
                    selectedStore.properties.user_properties.contacts.fax.job;
            } else {
                this.mainElement.querySelector(".storemap-detailitem-info-fax").style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-fax").style.display = "none";
        }

        // manager name
        if (selectedStore.properties.user_properties?.managerName) {
            this.mainElement.querySelector(".storemap-detailitem-info-contact").style.display = "";
            this.mainElement.querySelector(".storemap-contact").textContent =
                selectedStore.properties.user_properties.managerName;
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-contact").style.display = "none";
        }

        // email

        if (SETTINGS.isAviationPortal) {
            if (selectedStore.properties.user_properties.contacts?.email?.value) {
                this.mainElement.querySelector(".storemap-detailitem-info-email").style.display = "none";

                if (
                    selectedStore.properties.user_properties.contacts.email.name &&
                    selectedStore.properties.user_properties.contacts.email.name !== ""
                ) {
                    this.mainElement.querySelector(".storemap-email-link").textContent =
                        selectedStore.properties.user_properties.contacts.email.name;
                } else {
                    this.mainElement.querySelector(".storemap-email-link").textContent = "Email";
                }

                this.mainElement
                    .querySelector(".storemap-email-link")
                    .setAttribute("href", `mailto:${selectedStore.properties.user_properties.contacts.email.value}`);
            } else {
                this.mainElement.querySelector(".storemap-detailitem-info-email").style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-email").style.display = "none";
        }
        const moreInfoURL = store.properties?.contact?.website
            ? store.properties.contact.website
            : getMoreInfoLink(
                  store.properties.address.country_code,
                  this.language,
                  store.properties.user_properties.poiType,
                  store.properties.user_properties.location_id,
              );
        if (moreInfoURL) {
            this.mainElement.querySelector(".wm-poi-detail--section-content a").style.display = "";
            this.mainElement.querySelector(".wm-poi-detail--section-content a").setAttribute("href", moreInfoURL);

            const container = document.querySelector("#store-more-info-container");
            const freshContainer = container.cloneNode(true);
            container.replaceWith(freshContainer);

            freshContainer.addEventListener("click", (event) => {
                const link = freshContainer.querySelector("#store-more-info");
                // Only trigger programmatic click when clicking outside the anchor itself — prevents double-fire
                if (link && !link.contains(event.target)) {
                    link.click();
                }
            });
        } else {
            this.mainElement.querySelector(".wm-poi-detail--section-content a").style.display = "none";
        }
        // hours

        if (selectedStore.properties.opening_hours?.usual) {
            const ulOpeningHours = this.mainElement.querySelector(".wm-poi-detail--section-status-details ul");

            const nodes = ulOpeningHours.querySelectorAll("li");
            if (nodes) {
                for (const node of nodes) {
                    node.remove();
                }
            }

            const openingHoursArray = generateHoursLiArray(selectedStore);

            if (openingHoursArray.length !== 0) {
                for (const li of openingHoursArray) {
                    ulOpeningHours.append(li);
                }
                this.mainElement.querySelector(".storemap-detailitem-info-openinghours").style.display = "";
            } else {
                this.mainElement.querySelector(".storemap-detailitem-info-openinghours").style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-openinghours").style.display = "none";
        }
        // open 24/7
        $("#open247").toggle(open247(store));
        if (selectedStore.properties.tags.includes("fullev")) {
            $(".storemap-detailitem-24hours").addClass("storemap-storelistitem-elec");
        } else {
            $(".storemap-detailitem-24hours").removeClass("storemap-storelistitem-elec");
        }
        // fuel icons && requisition message
        if (SETTINGS.showPrices && store.properties.user_properties.poiType === "FUELING") {
            SERVICE_REGISTRY.priceService.getHotData(
                selectedStore.properties.user_properties.location_id,
                (productData) => {
                    this._generateProductContainer(selectedStore, productData);
                },
                selectedStore.properties.user_properties.business,
            );
        } else {
            this._generateProductContainer(selectedStore);
        }
        container.classList.remove("wm-hidden");
    }

    _feedRequisitionContainer(requMessage) {
        const requisitionInfo = this.mainElement.querySelector(".storemap-detailitem-info-requisition");

        if (requMessage && requMessage !== "") {
            requisitionInfo.textContent = requMessage;
            requisitionInfo.style.display = "";
        } else {
            requisitionInfo.style.display = "none";
        }
    }

    _generateProductContainer(store, prices) {
        const fuels = total.maps.parameters.fuel;
        const currentFuelTags = [];

        for (const tag of store.properties.tags) {
            if (fuels && fuels.indexOf(tag) !== -1) {
                currentFuelTags.push(tag);
            }
        }
        if (currentFuelTags.length === 0) {
            this.mainElement.querySelector("#store-fuel").classList.add("wm-hidden");
            this.mainElement.querySelector("#store-fuel").parentElement.classList.add("wm-hidden");
            if (this.mainElement.querySelector("#legal-notice")) {
                this.mainElement.querySelector("#legal-notice").style.display = "none";
            }
        } else {
            const fuelItemsContainer = this.mainElement.querySelector("#store-fuel");
            fuelItemsContainer.parentElement.classList.remove("wm-hidden");
            fuelItemsContainer.classList.remove("wm-hidden");

            let priceData;
            let priceUpdateText;

            fuelItemsContainer.innerHTML = "";
            for (const tag of currentFuelTags) {
                try {
                    if (prices) {
                        priceData = getProductHotData(prices, tag);
                    } else {
                        priceData = null;
                    }
                } catch (error) {
                    console.log(error);
                }
                fuelItemsContainer.innerHTML += templates.desktop.detailProductItem.render({
                    name: getProductName(store, tag),
                    iconUrl: getProductImageUrl(store, tag),
                    priceData,
                    crossIconUrl: `${SETTINGS.serverUrl}css/images/red-cross.png`,
                });
                if (priceData !== null) {
                    if (!priceUpdateText || priceUpdateText < priceData.updateDate) {
                        priceUpdateText = priceData.updateDate;
                    }
                }
            }

            this.mainElement.querySelector(".storemap-detailitem-info-fuel").style.display = "";
            if (priceUpdateText) {
                priceUpdateText = formatDateByCountry(priceUpdateText);
                if (this.mainElement.querySelector("#legal-notice-info")) {
                    this.mainElement.querySelector("#legal-notice-info").textContent = priceUpdateText;
                }
                if (this.mainElement.querySelector("#legal-notice")) {
                    this.mainElement.querySelector("#legal-notice").style.display = "";
                }
            } else {
                if (this.mainElement.querySelector("#legal-notice")) {
                    this.mainElement.querySelector("#legal-notice").style.display = "none";
                }
            }
        }
    }
}
